import type { ICategory } from "web/types/Category";
import type { ICategoryCount } from "web/types/CategoryCount";

import checkHasSubcategory from "./checkHasSubcategory";
import redirectToCategory from "./redirectToCategory";
import { CategoryListItemData } from "./types";

const buildCategoryListData = (
  treeCurrentUnique: ICategory[],
  categoriesTree: string[] | undefined,
  categoriesSizes: ICategoryCount[]
): CategoryListItemData[] => {
  return treeCurrentUnique
    .sort((a, b) => a?.position - b?.position)
    .map((category) => {
      const hasSubcategory = checkHasSubcategory(category.id, categoriesTree);
      const hasProducts = !!categoriesSizes.find((x) => +x.id === +category.id);

      return {
        id: category.id,
        name: category.name,
        hasSubcategory,
        hasProducts,
        redirectUrl: redirectToCategory(category),
      };
    })
    .filter((item) => item.hasProducts);
};

export default buildCategoryListData;
